module.exports = __webpack_public_path__ + "img/avatar.de9a30f5.png";